import useCurrencyNumber from '@/hooks/useCurrencyNumber'
import type { Product } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getProductLink } from '@/utils/next-util'
import type { MouseEventHandler } from 'react'
import CloseIcon from '../Icon/CloseIcon'
import ImageOptimize from '../ImageOptimize'

interface LatestSeenProductProps {
  className?: string
  data: Product
  onDelete: (data: Product) => void
}

const ViewedProduct = ({
  className,
  data,
  onDelete,
}: LatestSeenProductProps) => {
  const format = useCurrencyNumber()

  const handleDelete: MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault()
    e.stopPropagation()
    onDelete?.(data)
  }

  return (
    <a
      href={getProductLink(data)}
      className={`relative flex gap-3 rounded-sm border border-[#D1D5DB] bg-white px-2 py-3 ${className}`}
    >
      <ImageOptimize
        src={data.thumbnail}
        alt={getTranslate(data.name)}
        className='h-12 w-12'
        width={48}
        height={48}
      />
      <div>
        <p className='text-black line-clamp-2 pr-6 text-sm'>
          {getTranslate(data.name)}
        </p>
        <p className='mt-0.5 text-lg font-semibold text-secondary'>
          {format(data.finalPrice)}
        </p>
        <button
          onClick={handleDelete}
          className='absolute right-2 top-2 h-5 w-5'
        >
          <CloseIcon />
        </button>
      </div>
    </a>
  )
}

export default ViewedProduct
